// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { isTouchDevice } from 'fg-frontend/plugins/utils';
// You can also use <link> for styles
AOS.init({
  // Global settings:
  disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
  startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
  initClassName: 'aos-init', // class applied after initialization
  animatedClassName: 'aos-animate', // class applied on animation
  useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
  disableMutationObserver: false, // disables automatic mutations' detections (advanced)
  debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
  throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
  // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
  offset: 120, // offset (in px) from the original trigger point
  delay: 300, // values from 0 to 3000, with step 50ms
  duration: 1200, // values from 0 to 3000, with step 50ms
  easing: 'ease', // default easing for AOS animations
  once: false, // whether animation should happen only once - while scrolling down
  mirror: false, // whether elements should animate out while scrolling past them
  anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
});

const fragments = {
  OVERLAY: '[data-fragment="PromoLP.overlay"]',
  MENU_CONTAINER: '[data-fragment="PromoLP.menu.container"]',
  MENU_TOGGLE: '[data-fragment="PromoLP.menu.toggle"]',
  MENU: '[data-fragment="PromoLP.menu"]',
  MENU_LINKS: '[data-fragment="PromoLP.menu.links"]',
};

export default class PromoLP extends WebComponent {
  constructor(props) {
    super(props);
    this.bodyClick = this.bodyClick.bind(this);
    this.handleMenuState = this.handleMenuState.bind(this);
    this.buildAnchorMenu = this.buildAnchorMenu.bind(this);
    this.initNavigation = this.initNavigation.bind(this);
    this.state = {
      menuOpened: false,
    };
  }

  didMount() {
    this.body = document.body;
    if (isTouchDevice()) this.body.classList.add('touch-device');
    this.overlay = this.element.querySelector(fragments.OVERLAY);
    this.menuContainer = this.element.querySelector(fragments.MENU_CONTAINER);
    this.menuToggle = this.element.querySelector(fragments.MENU_TOGGLE);
    this.menu = this.element.querySelector(fragments.MENU);
    this.menuLinks = this.element.querySelector(fragments.MENU_LINKS);

    this.buildAnchorMenu();
    this.initNavigation();
    this.menuToggle.addEventListener('click', this.handleMenuState);
    this.body.addEventListener('click', this.bodyClick);

    const lang = document.getElementById('sectionMainLP').getAttribute('data-lang');

    if (lang && lang === 'de') {
      const otionalFields = document.querySelectorAll('.required-field');
      if (otionalFields) {
        otionalFields.forEach((field) => {
          field.innerHTML = 'wahlweise';
        });
      }
      const attachmentSelect = document.querySelector('.attachments-select');
      if (attachmentSelect) {
        attachmentSelect.value = 'Dateien wählen (max. 5MB)';
      }
    }
  }

  buildAnchorMenu() {
    // custom wysiwyg headings
    this.headings = this.element.querySelectorAll('.js_heading');

    if (this.headings) {
      this.headings.forEach((heading) => {
        // add anchor to heading
        const userSetAnchor = heading.querySelector('.promo-lp-anchor-name');
        if (userSetAnchor) {
          const userSetAnchorName = heading.querySelector('.promo-lp-anchor-name').innerHTML.replace(' ', '-');
          // giving ID so I can attach link to it later
          heading.setAttribute('id', userSetAnchorName);

          // create link to navigate
          const navLink = document.createElement('a');
          navLink.setAttribute('href', `#${userSetAnchorName}`);
          navLink.innerText = userSetAnchor.innerText;
          // remove user defined anchor title from the heading
          userSetAnchor.remove();
          // add link to the menu
          this.menuLinks.appendChild(navLink);
          this.menuLinks.classList.add('visible');
        }
      });
    }
  }

  initNavigation() {
    const anchors = this.menu.querySelectorAll('a');
    anchors.forEach((anchor) => {
      anchor.addEventListener('click', () => {
        if (window.innerWidth < 768) {
          this.setState({
            menuOpened: false,
          });
        }
      });
    });
  }

  handleMenuState() {
    // state toggle example
    this.setState({
      menuOpened: !this.state.menuOpened,
    });
  }

  bodyClick = (e) => {
    if (e.target == this.overlay) {
      // state toggle example
      this.setState({
        menuOpened: !this.state.menuOpened,
      });
    }
  }

  update = () => {
    const {
      menuOpened,
    } = this.state;
    classNames(this.body, { 'menu-opened': menuOpened });
    if (this.menuToggle) classNames(this.menuToggle, { active: menuOpened });
    if (this.overlay) classNames(this.overlay, { active: menuOpened });
    if (this.menu) classNames(this.menu, { active: menuOpened });
    if (this.menuContainer) classNames(this.menuContainer, { active: menuOpened });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/promoLP/PromoLP.js